import documentGalleryApi from "../api/document-gallery-api";

const generateLinkDocumentGalleryById = async (payload) => {
    const resp = await documentGalleryApi.generateLinkDocumentGalleryById(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const moveFile = async (payload) => {
    const resp = await documentGalleryApi.moveFile(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const createFolder = async (payload) => {
    const resp = await documentGalleryApi.createFolder(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const edit = async (payload) => {
    const resp = await documentGalleryApi.edit(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const remove = async (payload) => {
    const resp = await documentGalleryApi.remove(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const search = async (condition, pagination) => {
	try {
		const result = await documentGalleryApi.search(condition, pagination);
        // console.log(result);
		return { list: result.list, pagination: result.paginable };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const add = async (photoGallery) => {
    const resp = await documentGalleryApi.add(photoGallery);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const documentGalleryService = {
    generateLinkDocumentGalleryById,
    moveFile,
    createFolder,
    edit,
    search,
    remove,
    add
};

export default documentGalleryService;
